// extracted by mini-css-extract-plugin
export var communitycard = "CommunityCard-module--communitycard--SEtRA";
export var communitycard__title = "CommunityCard-module--communitycard__title--zGjP+";
export var communitycard__description = "CommunityCard-module--communitycard__description--3lFn8";